import etrApi from '../utils/etrApi';
import { put, select } from 'redux-saga/effects';
import { selectSelectedLanguage } from '../userData/selectors';
import {
  enqueueErrorSnackbar,
  enqueueSuccessSnackbar,
} from '../notifications/actionWrapper';
import { translate } from '../../utils/translation';

export function fetchApprovalProjectsSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.post(
        '/ppm/unit-projects/approval',
        payload,
      );
      if (!data) throw new Error('No data');
      yield put(actions.fetchProjectsSuccess(data));
    } catch (error) {
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotFetchProjects', lang),
        ),
      );
      yield put(actions.fetchProjectsError(error.message));
    }
  };
}

export function updateApprovalProjectsSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    const { approvalProjectFetchValues, ...updatePayload } = payload;
    try {
      const { data } = yield etrApi.put(
        '/ppm/unit-projects/approval',
        updatePayload,
      );
      if (!data) throw new Error('No data');
      yield put(
        enqueueSuccessSnackbar(translate('snackbarMessages.updated', lang)),
      );
      yield put(actions.updateProjectsSuccess(data));
      yield put(actions.fetchProjects(approvalProjectFetchValues));
    } catch (error) {
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotUpdateProjects', lang),
        ),
      );
      yield put(actions.updateProjectsError(error.message));
    }
  };
}

export function fetchApprovalProjectSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.get(
        `/ppm/unit-project/${payload}/approval`,
      );
      if (!data) throw new Error('No data');
      yield put(actions.fetchApprovalProjectSuccess(data));
    } catch (e) {
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotFetchProjects', lang),
        ),
      );
      yield put(actions.fetchApprovalProjectError(e.message));
    }
  };
}

export function captureRevisedBudgetSagaFactory(actions) {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    try {
      const { data } = yield etrApi.put(
        `/ppm/unit-projects/approval/revised-baseline`,
        payload,
      );
      if (!data) throw new Error('No data');
      yield put(actions.captureRevisedBudgetSuccess(data));
      yield put(enqueueSuccessSnackbar('Successfully captured revised budget'));
    } catch (e) {
      yield put(
        enqueueErrorSnackbar(
          translate('snackbarMessages.couldNotFetchProjects', lang),
        ),
      );
      yield put(actions.captureRevisedBudgetError(e.message));
    }
  };
}
